<template>
    <div>
        <section class="breadcrumb-section">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Site Map
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="cmn-section site-map-page pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section_heading_box">
                            <h1
                                class="heading1 section_heading position-relative text-center mb-0"
                            >
                                <span class="bg_secondary_white px_40"
                                    >Site Map</span
                                >
                            </h1>
                        </div>
                    </div>
                    <div class="col-md-12 site-map-box">
                        <div class="row">
                            <div class="col-md-12 site-map-start">
                                <a href="#" class="site-map-btn">Home</a>
                                <span class="site-map-root-line"></span>
                            </div>
                            <div class="col-md-12 site-map-root">
                                <div class="row">
                                    <div class="col-md-2">
                                        <span class="site-map-design"></span>
                                        <span class="site-map-root-line"></span>
                                        <a href="#" class="site-map-btn"
                                            >Apparel</a
                                        >
                                    </div>
                                    <div class="col-md-2">
                                        <span class="site-map-root-line"></span>
                                        <a href="#" class="site-map-btn"
                                            >Hats</a
                                        >
                                    </div>
                                    <div class="col-md-2">
                                        <span class="site-map-root-line"></span>
                                        <a href="#" class="site-map-btn"
                                            >Bags</a
                                        >
                                    </div>
                                    <div class="col-md-2">
                                        <span class="site-map-root-line"></span>
                                        <a href="#" class="site-map-btn"
                                            >Promos</a
                                        >
                                    </div>
                                    <div class="col-md-2">
                                        <span class="site-map-root-line"></span>
                                        <a href="#" class="site-map-btn"
                                            >Specials</a
                                        >
                                    </div>
                                    <div class="col-md-2">
                                        <span
                                            class="site-map-design right-side"
                                        ></span>
                                        <span class="site-map-root-line"></span>
                                        <a href="#" class="site-map-btn"
                                            >Design Studio</a
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "SiteMap",
    components: {},
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
    }
};
</script>
